import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=49a2af11&scoped=true&"
import script from "./SuppliersList.vue?vue&type=script&lang=js&"
export * from "./SuppliersList.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersList.vue?vue&type=style&index=0&id=49a2af11&lang=scss&scoped=true&"
import style1 from "./SuppliersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2af11",
  null
  
)

export default component.exports